// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.renewal.LeaseRenewalPreferenceWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  CreateLeaseExtensionPreferenceRequestDto,
  CreateLeaseExtensionPreferenceResponseDto,
  CreateLeaseRenewalResponseDto,
  CreateLeaseRenewalWithPreferencesRequestDto,
  SendRenewalProposalRequestDto,
} from '../..';

export const LeaseRenewalPreferenceWebApiHandler_createPreference_Path = '/api/web/v1/lease/renewal/createPreference';

/**
 * create lease extension preference
 */
export const LeaseRenewalPreferenceWebApiHandler_createPreference = (
  postData: CreateLeaseExtensionPreferenceRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    CreateLeaseExtensionPreferenceRequestDto,
    CreateLeaseExtensionPreferenceResponseDto
  >(
    {
      endpoint: LeaseRenewalPreferenceWebApiHandler_createPreference_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const LeaseRenewalPreferenceWebApiHandler_createWithPreferences_Path =
  '/api/web/v1/lease/renewal/createWithPreferences';

/**
 * create new lease renewal with preferences
 */
export const LeaseRenewalPreferenceWebApiHandler_createWithPreferences = (
  postData: CreateLeaseRenewalWithPreferencesRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreateLeaseRenewalWithPreferencesRequestDto, CreateLeaseRenewalResponseDto>(
    {
      endpoint: LeaseRenewalPreferenceWebApiHandler_createWithPreferences_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const LeaseRenewalPreferenceWebApiHandler_sendRenewalProposal_Path =
  '/api/web/v1/lease/renewal/sendRenewalProposal';

/**
 * send renewal proposal
 */
export const LeaseRenewalPreferenceWebApiHandler_sendRenewalProposal = (
  postData: SendRenewalProposalRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SendRenewalProposalRequestDto, void>(
    {
      endpoint: LeaseRenewalPreferenceWebApiHandler_sendRenewalProposal_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};
